<template>
  <div class="help-answer">
    <van-nav-bar title="在线帮助" @click-left="reBack" left-arrow :class="{'isiOSX':isiOSX}"/>
    <div class="moreProblem">
      <div class="description" v-for="item in list_classify" @click="showClassify(item.id)">{{item.name}}</div>
      <div class="description" v-for="item in list_problem" @click="showpoints(item.id)">{{item.title}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      list_classify: [],
      list_problem: [],
      anwser: [],
	    isiOSX: false
    };
  },
  created(){
		this.isiOSX = this.isIphoneX();
　　	this.getInfo();
	},
  methods: {
  	getInfo() {
    	this.$api.post("/cms/member/help/category/second", {id:this.$route.query.id}).then(res => {
	        this.list_classify = res.second;
	        this.list_problem = res.list;
	    });
    },
    showClassify(id) {
    	this.$router.push({
	      path: "/answer",
	      query: {
	        id: id,
	        isList: 1
	      }
    	});
    },
    showpoints(id) {
    	this.$router.push({
	      path: "/answer",
	      query: {
	        id: id,
	        isList: 2
	      }
    	});
    },
    hidepoints(){
      this.show=false;
    },
    reBack(){
      this.$router.go(-1);
    },
  }
};
</script>
<style lang='less' scoped>
.help-answer {
  background-color: #fff;
  height: 100%;
  .van-nav-bar {
    background: #f2f2f2;
    padding-top: 24px;
    position: relative;
    .van-nav-bar__title {
      font-size: 18px;
      color: #333;
    }
    .van-icon-arrow-left:before {
      display: none;
    }
    .van-nav-bar__left {
      left: 11px;
      .van-icon {
        width: 17px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/plane/reBack.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  .isiOSX {
		padding-top: 44px;
	}
  .moreProblem {
    background: #fff;
    width: 100%;
    margin: 0 auto;
    padding: 0 13px 0 12px;
    box-sizing: border-box;
    overflow: hidden;
    div {
      font-size: 12px;
      color: #333333;
    }
    .description {
    	overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			white-space: normal;
    	height: 41px;
      line-height: 41px;
      border-bottom: 1px solid #f2f2f2;
    }
    .description:last-child {
      border: none;
    }
  }
}


</style>



